import { makeStyles } from '@material-ui/core/styles';
import blue from '@material-ui/core/colors/blue';
import blueGrey from '@material-ui/core/colors/blueGrey';
import grey from '@material-ui/core/colors/grey';

const useStyles = makeStyles((theme) => ({
  textColorGreen: {
    color: 'green',
  },
  textRedColor: {
    color: 'red',
  },
  addButton: {
    color: theme.palette.getContrastText(blue[500]),
    backgroundColor: blue[500],
    '&:hover': {
      backgroundColor: blue[700],
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        backgroundColor: blue[500],
      },
    },
    alignSelf: 'flex-start',
    margin: 8,
  },
  submit: {
    color: theme.palette.getContrastText(blue[500]),
    backgroundColor: blue[500],
    '&:hover': {
      backgroundColor: blue[700],
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        backgroundColor: blue[500],
      },
    },
    alignSelf: 'flex-start',
    marginTop: 10,
  },
  editButton: {
    color: theme.palette.getContrastText(grey[800]),
    marginLeft: 5,
    marginRight: 5,
    backgroundColor: grey[500],
    '&:hover': {
      backgroundColor: grey[700],
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        backgroundColor: grey[500],
      },
    },
    alignSelf: 'flex-start',
  },
  viewButton: {
    marginRight: 5,
    marginLeft: 5,
    color: theme.palette.getContrastText(blueGrey[800]),
    backgroundColor: blueGrey[500],
    '&:hover': {
      backgroundColor: blueGrey[700],
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        backgroundColor: blueGrey[300],
      },
    },
    alignSelf: 'flex-start',
  },
  form: {},
  header_container: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '1rem',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  quote_block_green: {
    marginTop: '.5rem',
    background: '#d8ffd8',
    borderLeft: '.5rem solid #00cc00',
    borderRadius: '5px',
    padding: '0.4rem',
  },
  quote_block_yellow: {
    marginTop: '.5rem',
    background: '#FFECB3',
    borderLeft: '.5rem solid #FFC107',
    borderRadius: '5px',
    padding: '0.4rem',
  },
  quote_block_blue: {
    marginTop: '.5rem',
    background: '#B3E5FC',
    borderLeft: '.5rem solid #03A9F4',
    borderRadius: '5px',
    padding: '0.4rem',
  },
  container: {
    fontSize: '0.95rem',
    textAlign: 'right',
    padding: '.25rem 0',
  },
  service_goods_container: {
    fontSize: '0.9rem',
    textAlign: 'left',
    padding: '.5rem 0',
  },
  value: {
    fontWeight: 'bold',
    width: '100px',
    display: 'inline-block',
    border: 'rgba(128, 128, 128, 0.2) solid 1px',
    borderRadius: '.5rem',
    padding: '.2rem',
    marginLeft: '1rem',
    color: 'red',
  },
  service_goods_value: {
    textAlign: 'right',
    fontWeight: 'bold',
    width: '100px',
    display: 'inline-block',
    border: 'rgba(128, 128, 128, 0.2) solid 1px',
    borderRadius: '.5rem',
    padding: '.2rem',
    marginLeft: '.2rem',
    marginRight: '.2rem',
    color: 'black',
  },
  divide: {
    marginTop: '0.9rem',
    marginBottom: '0.9rem',
  },
}));

export default useStyles;
